<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div>
    <div v-if="applicationStore.isLoading" class="flex h-screen">
      <div class="m-auto">
        <i class="fas fa-circle-notch fa-spin text-secondary text-[5rem]"></i>
      </div>
    </div>

    <div v-else>
      <slot name="content">
      </slot>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useApplicationStore } from "@/stores/application";

export default {
  name: "LoadingComponent",
  computed: {
    ...mapStores(useApplicationStore)
  }
};
</script>

<style scoped>

</style>